module.exports = __webpack_public_path__ + "img/chevron-double-left.09659fe1.svg";